import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const modelSummaryManager = {
  getModelSummary(url: any) {
    return axiosInstance.v2.get(url);
  }
};

export default modelSummaryManager;
